__turbopack_context__.v({
  "body": "dialog-module__yini9G__body",
  "dialog": "dialog-module__yini9G__dialog",
  "dialog-fade": "dialog-module__yini9G__dialog-fade",
  "dialog-in": "dialog-module__yini9G__dialog-in",
  "dialog-up": "dialog-module__yini9G__dialog-up",
  "foot": "dialog-module__yini9G__foot",
  "head": "dialog-module__yini9G__head",
  "panel": "dialog-module__yini9G__panel",
  "subtitle": "dialog-module__yini9G__subtitle",
  "title": "dialog-module__yini9G__title",
  "titleBlock": "dialog-module__yini9G__titleBlock",
});
